<template>
    <div class="analysis-container">
            <el-col :lg="6" :sm="12" :xs="24">
                <div class="card-panel">
                    <div class="card-panel-icon-wrapper icon-artcile">
                        <svg-icon icon="article-create"></svg-icon>
                    </div>
                    <div class="card-panel-description">
                        <div class="card-panel-text">商家数量</div>
                        <span class="card-panel-num">{{ person.merchantCount }}</span>
                    </div>
                </div>
            </el-col>
            <el-col :lg="6" :sm="12" :xs="24">
                <div class="card-panel">
                    <el-row>
                        <div class="card-panel-icon-wrapper icon-user">
                            <svg-icon icon="peoples"></svg-icon>
                        </div>
                        <div class="card-panel-description">
                            <div class="card-panel-text">店铺数量</div>
                            <span class="card-panel-num">{{ person.shopCount }}</span>
                        </div>
                    </el-row>
                </div>
            </el-col>
            <el-col :lg="6" :sm="12" :xs="24">
                <div class="card-panel">
                    <el-row>
                        <div class="card-panel-icon-wrapper icon-comments">
                            <svg-icon icon="comments"></svg-icon>
                        </div>
                        <div class="card-panel-description">
                            <div class="card-panel-text">员工数量</div>
                            <span class="card-panel-num">{{ person.staffCount }}</span>
                        </div>
                    </el-row>
                </div>
            </el-col>
            <el-col :lg="6" :sm="12" :xs="24">
                <div class="card-panel">
                    <el-row>
                        <div class="card-panel-icon-wrapper icon-messages">
                            <svg-icon icon="message"></svg-icon>
                        </div>
                        <div class="card-panel-description">
                            <div class="card-panel-text">用户数量</div>
                            <span class="card-panel-num">{{ person.userCount }}</span>
                        </div>
                    </el-row>
                </div>
            </el-col>
    </div>
</template>
<script>
import {reqPersonStatistics} from "@/api/core/Home";

export default {
    name: 'PersonStatistics',
    methods: {
        async loadPerson() {
            let data = await reqPersonStatistics();
            this.person = data;
        },
    },
    async created() {
        await this.loadPerson();
    },
    data() {
        return {
            person: {
            },
        }
    }

}
</script>
<style lang="scss" scoped>
.analysis-container {
    //padding: 0px 25px 25px 25px;

    .el-card {
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    }

    .card-panel-chart {
        //padding: 20px;
        position: relative;
        vertical-align: middle;
        overflow: hidden;
        color: #666;
        background: #fff;
        margin: 10px;
        border-radius: 8px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    }

    .card-panel {
        //padding: 10px;
        position: relative;
        vertical-align: middle;
        overflow: hidden;
        color: #666;
        background: #fff;
        margin: 10px;
        border-radius: 8px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    }

    .card-panel-icon-wrapper {
        cursor: pointer;
        float: left;
        margin: 14px 0 0 14px;
        padding: 16px;
        -webkit-transition: all .38s ease-out;
        transition: all .38s ease-out;
        border-radius: 6px;

    }

    .icon-artcile {
        .svg-icon {
            color: #409EFF;
            width: 48px;
            height: 48px;
        }

        &:hover {
            background: #409EFF;

            .svg-icon {
                color: #fff;
            }
        }
    }

    .icon-user {
        .svg-icon {
            color: #67C23A;
            width: 48px;
            height: 48px;
        }

        &:hover {
            background: #67C23A;

            .svg-icon {
                color: #fff;
            }
        }
    }

    .icon-comments {
        .svg-icon {
            color: #F56C6C;
            width: 48px;
            height: 48px;
        }

        &:hover {
            background: #F56C6C;

            .svg-icon {
                color: #fff;
            }
        }
    }

    .icon-messages {
        .svg-icon {
            color: #E6A23C;
            width: 48px;
            height: 48px;
        }

        &:hover {
            background: #E6A23C;

            .svg-icon {
                color: #fff;
            }
        }
    }

    .card-panel-description {
        float: right;
        font-weight: 700;
        margin: 26px;
        margin-left: 0;

        .card-panel-text {
            line-height: 18px;
            color: rgba(0, 0, 0, .45);
            font-size: 16px;
            margin-bottom: 12px;
        }

        .card-panel-num {
            font-size: 20px;
            color: #666;
        }
    }

    .card-panel-chart-title {
        height: 20px;
        font-size: 18px;
        font-weight: 500;
        color: #494a4b;
    }
}
</style>
